module.exports = __webpack_public_path__ + "img/gopay_logo.8b3ce05f.svg";